import React from 'react'
import { EditUserForm } from '../components/Users/EditUserForm'
import '../css/Register.css';

export const EditUserPage = () => {
    return <EditUserForm />
   
}